import { painColor } from '@pelvia/shared/lib/patient/painColors'
import type { SleepPain } from '@pelvia/shared/hooks/patient/usePainPatterns'

/**
 * Average next-day pain bucketed by hours slept. Needs a meaningful sample, so
 * it stays hidden until there are at least 5 sleep→pain pairs.
 */
export default function SleepCard({ sleep }: { sleep?: SleepPain }) {
  if (!sleep || sleep.total_pairs < 5) return null

  return (
    <section className="card">
      <h3 className="pp-card-title">Sleep vs next-day pain</h3>
      <p className="pp-card-desc">
        Averaged across {sleep.total_pairs} sleep→pain pairs.
      </p>
      <div className="pp-sleep-chart">
        {sleep.buckets.map((b) => {
          const h = b.avg_pain != null ? Math.max(2, (b.avg_pain / 10) * 120) : 2
          return (
            <div key={b.bucket} className="pp-sleep-col">
              <span className="pp-sleep-val">{b.avg_pain ?? '—'}</span>
              <div
                className="pp-sleep-bar"
                style={{
                  height: `${h}px`,
                  background: b.avg_pain != null ? painColor(b.avg_pain) : 'var(--surface2)',
                }}
              />
              <div className="pp-sleep-label">{b.bucket}</div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
